/**
 * @fileoverview Schema constants for deepcut analysis
 */

// Confidence scoring constants
export const CONFIDENCE_SCORE_MIN = 0;
export const CONFIDENCE_SCORE_MAX = 1;
export const CONFIDENCE_THRESHOLD_UNCERTAIN = 0.8;
export const CONFIDENCE_THRESHOLD_MEDIUM = 0.6;



// Configuration flag to control whether core chips are always selected by default
// Set to false to use confidence-based selection for all chips
export const ALWAYS_SELECT_CORE_CHIPS = true;
